import { forwardRef, memo } from 'react';
import { Button, Text, VStack } from '@direct-frontend/components';
import { OrderDeliveryServices, type OrderDto } from '@/shared/api/order';
import { type PickupPoint } from '@/shared/api/pickupPoint';

interface MapSubmitButtonComponentProps {
    order: OrderDto;
}

interface MapSubmitButtonProps {
    point?: PickupPoint;
    isSubmitting: boolean;
    onSubmit: VoidFunction;
}

const getButtonBottomText = (order: OrderDto, point?: PickupPoint) => {
    if (order.client.need_ozon_registration && point?.serviceType === OrderDeliveryServices.OZON) {
        return 'Для оформления доставки в этот ПВЗ нужен аккаунт\u00a0OzonID';
    }

    return;
};

const MapSubmitButtonComponent = memo(
    forwardRef<HTMLElement, MapSubmitButtonComponentProps & MapSubmitButtonProps>(
        function MapSubmitButton(props, forwardedRef) {
            const { order, isSubmitting, onSubmit, point } = props;

            const text = getButtonBottomText(order, point);

            return (
                <VStack ref={forwardedRef} gap="16">
                    <Button size="m" color="accent" isDisabled={isSubmitting} onClick={onSubmit}>
                        Заберу отсюда
                    </Button>

                    {text && (
                        <Text size="mc" textAlign="center" role="supplementary">
                            {text}
                        </Text>
                    )}
                </VStack>
            );
        }
    )
);

export function mapSubmitButtonRender(componentProps: MapSubmitButtonComponentProps) {
    return forwardRef<HTMLElement, MapSubmitButtonProps>(function MapSubmitButtonWrapper(props, ref) {
        return <MapSubmitButtonComponent {...componentProps} {...props} ref={ref} />;
    });
}
